'use client';

import { useEffect } from 'react';
import { track } from '@/lib/analytics';

const safePath = () => window.location.pathname;

export function AnalyticsAdapter() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const link = (event.target as Element | null)?.closest('a[href]') as HTMLAnchorElement | null;
      if (!link) return;
      const href = link.getAttribute('href') ?? '';
      if (href.startsWith('tel:')) return track({ name: 'phone_click' });
      if (href.startsWith('mailto:')) return track({ name: 'email_click' });
      if (/^https:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href)) return track({ name: 'whatsapp_click' });
      const product = href.match(/^\/products\/([^/?#]+)\/?/);
      if (product) track({ name: 'product_interest', product_key: product[1] });
      if (safePath().startsWith('/blog/') && (href.startsWith('/demo/') || href.startsWith('/contact/') || href.startsWith('/api/'))) {
        track({ name: 'article_cta_click' });
      }
      if (link.classList.contains('button') || link.className.includes('btn') || link.className.includes('cta')) {
        track({ name: 'cta_click', cta_id: link.dataset.ctaId ?? (href.split(/[?#]/)[0] || 'internal'), page_path: safePath() });
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  return null;
}
